import React, { useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { useGallery, blankGalleryItem } from "../../hooks/useGallery";
import GalleryItemCard from "./GalleryItemCard";
import GalleryEditModal from "./GalleryEditModal";

const GalleryEditor = () => {
  const { items, loading, save, remove, move } = useGallery();
  const [editing, setEditing] = useState(null);

  return (
    <div data-testid="admin-gallery-page">
      <header className="flex items-end justify-between flex-wrap gap-4 mb-8">
        <div>
          <div className="font-display text-[11px] uppercase tracking-[0.3em] text-[#0A192F]/60">
            Photos
          </div>
          <h1 className="mt-2 font-display font-black text-4xl text-[#0A192F] tracking-tighter">
            Gallery ({items.length})
          </h1>
        </div>
        <button
          onClick={() => setEditing(blankGalleryItem())}
          data-testid="admin-gallery-add"
          className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#0A192F] px-6 py-3 font-display text-xs uppercase tracking-[0.25em] font-bold hover:bg-[#0A192F] hover:text-white transition-colors"
        >
          <Plus size={14} /> Add Photo
        </button>
      </header>

      {loading ? (
        <div className="flex items-center justify-center py-20 text-[#0A192F]/40">
          <Loader2 className="animate-spin mr-2" size={18} /> Loading…
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((g, i) => (
            <GalleryItemCard
              key={g.id}
              item={g}
              isFirst={i === 0}
              isLast={i === items.length - 1}
              onEdit={() => setEditing(g)}
              onMove={(dir) => move(g.id, dir)}
              onDelete={remove}
            />
          ))}
        </div>
      )}

      {editing && (
        <GalleryEditModal
          item={editing}
          onChange={setEditing}
          onSave={() => save(editing, items.length)}
          onClose={() => setEditing(null)}
        />
      )}
    </div>
  );
};

export default GalleryEditor;
